import Vue from 'vue'
import App from './App.vue'
import router from "./router"
import Vuex from 'vuex'
import store from '@/store/store'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper';
import './assets/iconfont/iconfont'
import './assets/less/currency.less'
import 'swiper/dist/css/swiper.css'
import 'swiper/dist/js/swiper'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
// 插件
import jump from './assets/js/jump'
import maskVideo from './assets/js/maskVideo'
import maskPDF from './assets/js/maskPDF'

Vue.config.productionTip = false;
Vue.use(Vuex);
Vue.use(VideoPlayer)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */ )
Vue.prototype.$axios = axios;
// 引入插件
Vue.use(jump);
Vue.use(maskVideo);
Vue.use(maskPDF);

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if(to.meta.content){
        let head = document.getElementsByTagName('head');
        let meta = document.createElement('meta');
        document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
        document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
        meta.content = to.meta.content;
        head[0].appendChild(meta)
    }
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
});

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
